import * as React from "react";
import { useState } from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import { Delete, Eye, Pencil, Trash } from "lucide-react";
import { Autocomplete, Switch, TextField } from "@mui/material";
import { deepPurple, purple } from "@mui/material/colors";

const columns = [
  { id: "SrNo", label: "Sr.No.", minWidth: "2.11111vw" },
  { id: "Tax", label: "Tax", minWidth: "12.81111vw" },
  { id: "Net", label: "Net", minWidth: "3.61111vw" },
  { id: "type", label: "@ %", minWidth: "6.11111vw" },
  { id: "Amount", label: "Amount (₹)", minWidth: "6.11111vw" },
];

const options = [
  "VKC/3061",
  "VKC/3062",
  "VKC/3063",
  "VKC/3064",
  "VKC/3065",
  "VKC/3066",
  "VKC/3067",
  "VKC/3068",
  "VKC/3069",
  "VKC/3070",
  "VKC/3071",
];

const nets = ["+", "-"];

function createData(SrNo, Tax, Net, type, Amount) {
  return { SrNo, Tax, Net, type, Amount };
}

export default function TaxTable({ add, setadd }) {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChange = (event, value) => {
    settax(value);
  };

  const handleChangenet = (event, value) => {
    stenet(value);
  };

  const [rows, setrow] = useState([
    createData("1", "Discount", "-", "10.714", "5528.42"),
    createData("2", "SGST", "+", "10.714", "5528.42"),
    createData("3", "CGST", "+", "10.714", "5528.42"),
    createData("4", "Frieght & Forwarding Charges", "+", "10.714", "5528.42"),
  ]);

  const [Tax, settax] = useState("");
  const [net, stenet] = useState("");
  const [percentage, setpercentage] = useState("");
  const [amount, setamount] = useState("");

  const handleAddRow = () => {
    const data = {
      SrNo: rows.length + 1,
      Tax: Tax,
      Net: net,
      type: percentage,
      Amount: amount,
    };

    if (Tax === "" || net === "" || percentage === "" || amount === "") return;
    else setrow([...rows, data]);

    settax("");
    stenet("");
    setpercentage("");
    setamount("");
    setadd(true);
  };

  const [rowdata, setrowdata] = useState(null);

  const deleteEmployee = name => {
    setadd(!add);
    return setrow([...rows.filter(item => item.Tax !== name)]);
  };

  return (
    <div className={`${add === true ? "w-[100%]" : "w-full"}`}>
      <TableContainer sx={{ maxHeight: 480, maxWidth: add ? 720 : 640 }}>
        <Table stickyHeader aria-label="sticky table" className="">
          <TableHead>
            <TableRow>
              {columns.map(column => (
                <TableCell
                  key={column.id}
                  align="center"
                  sx={{ minWidth: column.minWidth }}
                  style={{
                    backgroundColor: "#EAEAEA",
                    fontWeight: "700",
                    fontSize: "16px",
                  }}
                  className={`font-outfit ${
                    column.id === "Amount" ? "" : "border-r-2 border-zinc-300"
                  }`}>
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map(row => {
              return (
                <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                  <TableCell
                    key={row.id}
                    style={{ padding: "10px 0" }}
                    className={`whitespace-nowrap text-ellipsis box-border overflow-hidden h-[4.7vh]`}>
                    <div
                      className={`flex items-center justify-center px-1 border-r-2 border-zinc-400 font-outfit`}>
                      {row.SrNo}
                    </div>
                  </TableCell>
                  <TableCell
                    key={row.id}
                    style={{ padding: "10px 0" }}
                    className={`whitespace-nowrap text-ellipsis box-border overflow-hidden h-[4.7vh]`}>
                    <div
                      className={`flex items-center justify-center px-1 border-r-2 border-zinc-400 font-outfit`}>
                      {row.Tax}
                    </div>
                  </TableCell>
                  <TableCell
                    key={row.id}
                    style={{ padding: "10px 0" }}
                    className={`whitespace-nowrap text-ellipsis box-border overflow-hidden h-[4.7vh]`}>
                    <div
                      className={`flex items-center justify-center px-1 border-r-2 border-zinc-400 font-outfit`}>
                      {row.Net}
                    </div>
                  </TableCell>
                  <TableCell
                    key={row.id}
                    style={{ padding: "10px 0" }}
                    className={`whitespace-nowrap text-ellipsis box-border overflow-hidden h-[4.7vh]`}>
                    <div
                      className={`flex items-center justify-center px-1 border-r-2 border-zinc-400 font-outfit`}>
                      {row.type}
                    </div>
                  </TableCell>
                  <TableCell
                    key={row.id}
                    style={{ padding: "10px 0" }}
                    className={`whitespace-nowrap text-ellipsis box-border overflow-hidden h-[4.7vh]`}>
                    <div
                      className={`flex items-center justify-center px-1 font-outfit`}>
                      {row.Amount}
                    </div>
                  </TableCell>
                  <TableCell
                    align="center"
                    className="cursor-pointer"
                    style={{ display: add ? "inline-block" : "none" }}
                    onClick={() => {
                      setrowdata(row.Tax);
                      deleteEmployee(row.Tax);
                    }}>
                    <Trash color="red" size={18} />
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>

      <div
        className={`w-[100%] mt-4 flex items-center justify-center ${
          add === false ? "hidden  w-[20%]" : ""
        } `}>
        <div className="w-[90%] flex flex-row">
          <div className="flex w-[28%] py-2 flex-row items-center h-[65%] allProductSearchBoxContainer"></div>
          <div className="flex w-[68%] mx-1 flex-row items-center allProductSearchBoxContainer">
            <Autocomplete
              id="combo-box-demo"
              freeSolo
              value={Tax}
              size="small"
              options={options}
              sx={{ width: 240 }}
              className=" overflow-y-auto no-scrollbar"
              onChange={handleChange}
              renderInput={params => (
                <TextField
                  {...params}
                  label="Tax..."
                  className=" no-scrollbar overflow-y-auto"
                  variant="standard"
                />
              )}
            />
          </div>
          <div className="flex w-[20%] flex-row items-center allProductSearchBoxContainer ">
            <Autocomplete
              id="combo-box-demo"
              freeSolo
              value={net}
              size="small"
              options={nets}
              sx={{ width: 70 }}
              className=" overflow-y-auto no-scrollbar"
              onChange={handleChangenet}
              renderInput={params => (
                <TextField
                  {...params}
                  label="Net..."
                  className=" no-scrollbar overflow-y-auto"
                  variant="standard"
                />
              )}
            />
          </div>
          <div className="flex w-[34%] mx-3 mt-3 flex-row items-center allProductSearchBoxContainer ">
            <TextField
              variant="standard"
              type="text"
              placeholder="Percentage..."
              className=" w-[90%] text-[#83899F] allProductSearchBox outfit-regular"
              value={percentage}
              onChange={e => {
                setpercentage(e.target.value);
              }}
            />
          </div>
          <div className="flex w-[37%] flex-row items-center mt-3 allProductSearchBoxContainer ">
            <TextField
              variant="standard"
              type="text"
              placeholder="Amount..."
              className=" w-[90%] text-[#83899F] allProductSearchBox outfit-regular"
              value={amount}
              onChange={e => {
                setamount(e.target.value);
              }}
            />
          </div>
        </div>

        <div className="w-[10%] ml-2">
          <button
            className="bg-[#5652B0] rounded-md px-6 py-2 text-[18px] font-medium font-outfit text-[#fff] flex items-center justify-center flex-row"
            onClick={handleAddRow}>
            Add
          </button>
        </div>
      </div>
    </div>
  );
}
